@if (!loading()) {
  <form class="profile-form" [formGroup]="form" (ngSubmit)="save()">

    <!-- Personal ----------------------------------------------------------- -->
    <ut-form-section
      icon="user"
      [title]="'profile.personal' | translate"
      [description]="'profile.personal description' | translate"
      formGroupName="personal"
    >
      <div class="profile-form__personal">
        <div class="profile-form__avatar">
          <ut-avatar-upload
            formControlName="avatarUuid"
            [name]="displayName()"
            [removeLabel]="'button.remove' | translate"
          ></ut-avatar-upload>
          <span class="profile-form__avatar-hint">
            {{ 'profile.upload photo' | translate }}
          </span>
        </div>
        <div class="profile-form__grid profile-form__grid--2">
          <ut-input
            formControlName="givenName"
            [label]="'profile.given name' | translate"
            [required]="true"
            [error]="fieldError(form.controls.personal.controls.givenName)"
          ></ut-input>
          <ut-input
            formControlName="middleName"
            [label]="'profile.middle name' | translate"
          ></ut-input>
          <ut-input
            formControlName="lastName"
            [label]="'profile.last name' | translate"
            [required]="true"
            [error]="fieldError(form.controls.personal.controls.lastName)"
          ></ut-input>
          <ut-date-input
            formControlName="birthDate"
            [label]="'profile.birthdate' | translate"
          ></ut-date-input>
        </div>
      </div>
    </ut-form-section>

    <!-- Contact ------------------------------------------------------------ -->
    <ut-form-section
      icon="mail"
      [title]="'profile.contact' | translate"
      [description]="'profile.contact description' | translate"
      formGroupName="contact"
    >
      <div class="profile-form__grid profile-form__grid--2">
        <ut-input
          class="profile-form__span-2"
          formControlName="email"
          [label]="'profile.email' | translate"
          type="email"
          [required]="true"
          [readonly]="true"
          [hint]="'profile.email readonly hint' | translate"
          [error]="fieldError(form.controls.contact.controls.email)"
        ></ut-input>
        <ut-input
          class="profile-form__span-2"
          formControlName="phone"
          [label]="'profile.phone' | translate"
          type="text"
        ></ut-input>
      </div>
    </ut-form-section>

    <!-- Address ------------------------------------------------------------ -->
    <ut-form-section
      icon="map-pin"
      [title]="'profile.address' | translate"
      [description]="'profile.address description' | translate"
      formGroupName="address"
    >
      <div class="profile-form__grid profile-form__grid--address">
        <ut-input
          class="profile-form__addr-street"
          formControlName="street"
          [label]="'profile.street' | translate"
          [required]="true"
          [error]="fieldError(form.controls.address.controls.street)"
        ></ut-input>
        <ut-input
          class="profile-form__addr-house"
          formControlName="houseNumber"
          [label]="'profile.house number' | translate"
          type="text"
          [required]="true"
          [error]="fieldError(form.controls.address.controls.houseNumber)"
        ></ut-input>
        <ut-input
          class="profile-form__addr-houseext"
          formControlName="houseNumberExtension"
          [label]="'profile.house number ext' | translate"
        ></ut-input>
        <ut-input
          class="profile-form__addr-zip"
          formControlName="zipcode"
          [label]="'profile.zipcode' | translate"
          [required]="true"
          [error]="fieldError(form.controls.address.controls.zipcode)"
        ></ut-input>
        <ut-input
          class="profile-form__addr-city"
          formControlName="city"
          [label]="'profile.city' | translate"
          [required]="true"
          [error]="fieldError(form.controls.address.controls.city)"
        ></ut-input>
        <ut-country-picker
          class="profile-form__span-2"
          formControlName="country"
          [label]="'profile.country' | translate"
          [required]="true"
          [placeholder]="'profile.select country' | translate"
        ></ut-country-picker>
      </div>
    </ut-form-section>

    <!-- Preferences -------------------------------------------------------- -->
    <ut-form-section
      icon="globe"
      [title]="'profile.preferences' | translate"
      [description]="'profile.preferences description' | translate"
      formGroupName="preferences"
    >
      <div class="profile-form__grid profile-form__grid--2">
        <ut-select
          class="profile-form__span-2"
          formControlName="language"
          [label]="'language.label' | translate"
          [options]="languageOptions"
          [required]="true"
          [searchable]="false"
        ></ut-select>
        <ut-select
          class="profile-form__span-2"
          formControlName="filterLanguages"
          [label]="'language.filter' | translate"
          [options]="filterLanguageOptions"
          [multiple]="true"
          [clearable]="true"
          [searchable]="false"
          [placeholder]="'language.filter placeholder' | translate"
        ></ut-select>
        <ut-select
          class="profile-form__span-2"
          formControlName="timezone"
          [label]="'profile.timezone' | translate"
          [options]="timezoneOptions"
          [required]="true"
          [searchable]="true"
        ></ut-select>
      </div>
    </ut-form-section>

    <!-- Sticky action bar -------------------------------------------------- -->
    <div class="profile-form__actions">
      <div class="profile-form__actions-state">
        @if (form.dirty && !saving()) {
          <span class="profile-form__dirty">
            {{ 'profile.unsaved changes' | translate }}
          </span>
        }
      </div>
      <div class="profile-form__actions-buttons">
        <ut-button
          type="button"
          variant="ghost"
          size="md"
          (clicked)="cancel()"
        >{{ 'button.cancel' | translate }}</ut-button>
        <ut-button
          type="submit"
          variant="primary"
          size="md"
          iconLeft="check"
          [loading]="saving()"
          [disabled]="!form.valid || !form.dirty"
        >{{ 'button.save' | translate }}</ut-button>
      </div>
    </div>
  </form>
}
